import { createSlice } from "@reduxjs/toolkit";
import { OrdersInitialStore } from "./types.store";
// eslint-disable-next-line import/no-cycle
import { handleGetOrdersRequest } from "./thunk.store";

const initialState: OrdersInitialStore = {
  allOrders: [],
};

const OrdersStore = createSlice({
  initialState,
  name: "ordersData",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(handleGetOrdersRequest.fulfilled, (state, action) => {
      state.allOrders = action.payload;
    });
  },
});

export default OrdersStore.reducer;
